import React from 'react';
import { IconArrowsUpDown } from '../icons/arrows-up-down';
import { IconArrowUp } from '../icons/arrow-up';
import { IconArrowDown } from '../icons/arrow-down';
import { OrderEnum } from '../../../defs/api';
import { cn } from '../../../utils/tailwind';

interface SortButtonProps {
    order: OrderEnum | null | undefined | '';
    onSortChange: (newOrder: OrderEnum | null) => void;
}

export const SortButton: React.FC<SortButtonProps> = ({ onSortChange, order }: SortButtonProps) => {
    const wrapperClassName = (isActive?: boolean) =>
        cn(
            'cursor-pointer [&_i]:h-[1.2rem] [&_i]:w-[1.2rem] [&_i]:min-w-[1.2rem] [&_i]:text-text-muted [&_i]:transition-colors hover:[&_i]:text-text',
            isActive && '[&_i]:text-brand-secondary hover:[&_i]:text-brand-secondary',
        );

    if (!order) {
        return (
            <div className={wrapperClassName()} onClick={() => onSortChange(OrderEnum.Desc)}>
                <IconArrowsUpDown />
            </div>
        );
    }
    return (
        <>
            {order === OrderEnum.Asc && (
                <div className={wrapperClassName(true)} onClick={() => onSortChange(null)}>
                    <IconArrowUp />
                </div>
            )}
            {order === OrderEnum.Desc && (
                <div className={wrapperClassName(true)} onClick={() => onSortChange(OrderEnum.Asc)}>
                    <IconArrowDown />
                </div>
            )}
        </>
    );
};
